export default {
  'aiBilling.title': 'AI Billing',
  'aiBilling.back': 'Back',
  'aiBilling.description': 'Configure billing profile, limits, budget periods and credits.',

  'aiBilling.tabs.profile': 'Profile',
  'aiBilling.tabs.limits': 'Limits',
  'aiBilling.tabs.periods': 'Periods',
  'aiBilling.tabs.grants': 'Grants',

  'aiBilling.validation.required': 'This field is required.',
  'aiBilling.validation.invalidEmails': 'One or more emails have an invalid format.',
  'aiBilling.validation.amountGreaterThanZero': 'Amount must be greater than 0.',

  'aiBilling.text.active': 'Active',
  'aiBilling.text.inactive': 'Inactive',

  'aiBilling.profile.billingMode': 'Billing mode',
  'aiBilling.profile.budgetEditMode': 'Budget edit mode',
  'aiBilling.profile.currency': 'Currency',
  'aiBilling.profile.isBudgetEnabled': 'Budget enabled',
  'aiBilling.profile.monthlyIncludedCreditOverrideAmount': 'Monthly included credit override',
  'aiBilling.profile.notifyMonthlyCreditGranted': 'Notify monthly credit granted',
  'aiBilling.profile.alertEmails': 'Alert emails',
  'aiBilling.profile.monthlyBudgetAmount': 'Monthly budget amount',
  'aiBilling.profile.maxSelfServiceBudgetAmount': 'Max self-service budget amount',
  'aiBilling.profile.budgetExceededBehavior': 'Budget exceeded behavior',

  'aiBilling.billingMode.creditCard': 'Credit card',
  'aiBilling.billingMode.manualBilling': 'Manual billing',

  'aiBilling.budgetEditMode.selfService': 'Self-service',
  'aiBilling.budgetEditMode.requiresAutomyApproval': 'Requires Automy approval',
  'aiBilling.budgetEditMode.automyOnly': 'Automy only',

  'aiBilling.budgetExceededBehavior.blockUsage': 'Block usage',
  'aiBilling.budgetExceededBehavior.allowWithWarning': 'Allow with warning',

  'aiBilling.currency.usd': 'USD',

  'aiBilling.limits.monthlyBudget': 'Monthly budget',
  'aiBilling.limits.monthlyBudgetAmount': 'Monthly budget amount',
  'aiBilling.limits.alerts': 'Alerts',
  'aiBilling.limits.addAlert': 'Add alert',
  'aiBilling.limits.addAlert.description':
    'Configure a consumption threshold and notification recipients for this alert.',
  'aiBilling.limits.editAlert': 'Edit alert',
  'aiBilling.limits.editAlert.description':
    'Update the threshold, recipients, or notification settings for this alert.',
  'aiBilling.limits.sendToOrganizationOwners': 'Send to organization owners',
  'aiBilling.limits.budgetDisabled': 'Budget is disabled in profile. Enable budget to edit limits.',
  'aiBilling.limits.deleteConfirm.title': 'Delete alert',
  'aiBilling.limits.deleteConfirm.content': 'Do you want to delete this consumption alert?',

  'aiBilling.limits.columns.threshold': 'Threshold',
  'aiBilling.limits.fields.thresholdPercentage': 'Threshold (%)',
  'aiBilling.limits.columns.emailSubjectPrefix': 'Email subject prefix',
  'aiBilling.limits.columns.emails': 'Emails',

  'aiBilling.periods.filter.status': 'Filter by status',
  'aiBilling.periods.columns.period': 'Period',
  'aiBilling.periods.columns.budget': 'Consumed / budget',
  'aiBilling.periods.columns.aiUsage': 'AI usage / budget',
  'aiBilling.periods.columns.credit': 'Credit consumed / granted',
  'aiBilling.periods.columns.includedCredit': 'Included credit',
  'aiBilling.periods.columns.promotionalCredit': 'Promotional',
  'aiBilling.periods.columns.paidCredit': 'Paid credit',
  'aiBilling.periods.columns.crossPeriodMovements': 'Movements between periods',
  'aiBilling.periods.columns.billableAmount': 'Billable amount',
  'aiBilling.periods.columns.periodStart': 'Start',
  'aiBilling.periods.columns.periodEnd': 'End',

  'aiBilling.periods.aiUsage.ofBudget': 'of {budget}',
  'aiBilling.periods.credit.available': 'available',
  'aiBilling.periods.credit.unused': 'unused',
  'aiBilling.periods.credit.expired': 'expired',
  'aiBilling.periods.credit.consumedOfGranted': '{consumed} of {granted} consumed',
  'aiBilling.periods.movements.appliedTo': '{amount} applied to {period}',
  'aiBilling.periods.movements.receivedFrom': '{amount} received from {period}',
  'aiBilling.periods.movements.appliedToOther': '{amount} applied to other periods',
  'aiBilling.periods.movements.receivedFromOther': '{amount} received from other periods',
  'aiBilling.periods.movements.moreCount': '+{count} more',

  'aiBilling.periods.tooltip.aiUsage':
    'AI usage that occurred during the period. Does not include credits or transfers.',
  'aiBilling.periods.tooltip.includedConsumed':
    'Included credit consumed from the grant originated in this period. May include amounts applied to prior periods.',
  'aiBilling.periods.tooltip.appliedToOther':
    'Portion of consumed credit applied to another period. This is a breakdown; do not subtract it again from consumed.',
  'aiBilling.periods.tooltip.receivedFromOther':
    'Credit received from grants originated in other periods.',
  'aiBilling.periods.tooltip.billable':
    'Amount to bill after applying credits. Can be greater than zero even when AI usage is below budget if own credit was used in another period.',
  'aiBilling.periods.tooltip.crossPeriodMovements':
    'Credits from this period applied to others, or received from grants originated in other periods.',

  'aiBilling.period.status.active': 'Active',
  'aiBilling.period.status.closed': 'Closed',
  'aiBilling.period.status.blocked': 'Blocked',

  'aiBilling.grants.columns.period': 'Period',
  'aiBilling.grants.columns.balance': 'Available / original',
  'aiBilling.grants.columns.originalAmount': 'Original amount',
  'aiBilling.grants.columns.remainingAmount': 'Remaining amount',
  'aiBilling.grants.columns.currency': 'Currency',
  'aiBilling.grants.columns.validFrom': 'Valid from',
  'aiBilling.grants.columns.expiresAt': 'Expires at',
  'aiBilling.grants.columns.reason': 'Reason',

  'aiBilling.grants.recharge': 'Recharge',
  'aiBilling.grants.rechargeCredits': 'Recharge credits',
  'aiBilling.grants.rechargeCredits.title': 'Recharge AI credits',
  'aiBilling.grants.rechargeCredits.description': 'Add balance for AI agent consumption in AUTOMY.',
  'aiBilling.grants.rechargeCredits.submit': 'Continue to payment',
  'aiBilling.grants.rechargeCredits.error.missingCheckoutUrl':
    'Payment URL was not received. Please try again.',

  'aiBilling.grants.grantManual': 'Grant manual credit',
  'aiBilling.grants.grantManual.description':
    'Use this option only for bonuses, promotions, compensations, or internal adjustments.',
  'aiBilling.grants.grantManual.submit': 'Grant credit',
  'aiBilling.grants.usage.title': 'Credit usage',
  'aiBilling.grants.usage.description':
    'View consumption ledger entries for the selected credit grant.',
  'aiBilling.grants.usage.columns.billingOperationId': 'Billing operation ID',
  'aiBilling.grants.usage.columns.aiConsumptionId': 'AI consumption ID',
  'aiBilling.grants.usage.columns.referenceKey': 'Reference key',
  'aiBilling.grants.usage.columns.sequence': 'Sequence',
  'aiBilling.grants.usage.columns.amount': 'Amount',
  'aiBilling.grants.fields.amount': 'Amount',
  'aiBilling.grants.fields.currency': 'Currency',
  'aiBilling.grants.fields.isCustomerVisible': 'Customer visible',
  'aiBilling.grants.fields.isRefundable': 'Refundable',
  'aiBilling.grants.fields.reason': 'Reason',
  'aiBilling.grants.fields.internalComment': 'Internal comment',
  'aiBilling.grants.fields.confirmedBy': 'Confirmed by',
  'aiBilling.grants.fields.associateToCurrentPeriod': 'Associate to current period',
  'aiBilling.grants.fields.validFrom': 'Valid from',
  'aiBilling.grants.fields.expiresAt': 'Expires at',

  'aiBilling.grant.type.planIncludedMonthlyCredit': 'Plan included',
  'aiBilling.grant.type.promotionalCredit': 'Promotional',
  'aiBilling.grant.type.manualBonus': 'Manual bonus',
  'aiBilling.grant.type.supportCompensation': 'Support compensation',
  'aiBilling.grant.type.paidCredit': 'Paid credit',
  'aiBilling.grant.type.adjustment': 'Adjustment',
  'aiBilling.grant.type.purchaseOrderCredit': 'Purchase order',

  'aiBilling.consumptionLedgerKind.includedCredit': 'Included credit',
  'aiBilling.consumptionLedgerKind.promotionalCredit': 'Promotional credit',
  'aiBilling.consumptionLedgerKind.paidCredit': 'Paid credit',
  'aiBilling.consumptionLedgerKind.billable': 'Billable',
  'aiBilling.consumptionLedgerKind.billableSettlement': 'Billable settlement',
  'aiBilling.consumptionLedgerKind.purchaseOrderCredit': 'Purchase order',
};
